import React from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import Header from "../../Header";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";

function initialsFrom(name) {
    if (!name) return "?";
    return name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0].toUpperCase())
        .join("");
}

const UserDetails = () => {
    const userInfo = useSelector((s) => s.userLogin?.userInfo);
    const data = userInfo?.data || {};
    const organization = useSelector((s) => s.organizationDetails?.organization);

    return (
        <>
            <div className="container-scroller">
                <Header />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <Box component="main" className="main-panel" sx={{ display: "flex", flexDirection: "column" }}>
                        <Box sx={{ flex: 1, py: { xs: 2, md: 3 } }}>
                            <Container maxWidth="md" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
                                <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, border: "1px solid", borderColor: "divider" }}>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={3} alignItems={{ xs: "flex-start", sm: "center" }} sx={{ mb: 3 }}>
                                        <Avatar
                                            sx={{
                                                width: 72,
                                                height: 72,
                                                bgcolor: "primary.main",
                                                color: "secondary.dark",
                                                fontWeight: 800,
                                                fontSize: 24,
                                            }}
                                        >
                                            {initialsFrom(data.name)}
                                        </Avatar>
                                        <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="h3" component="h1" sx={{ mb: 0.5 }} noWrap>
                                                {data.name || "—"}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
                                                {data.email || "—"}
                                            </Typography>
                                            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                                                {data.role && (
                                                    <Chip label={data.role} size="small" variant="outlined" />
                                                )}
                                                {organization?.user_role && (
                                                    <Chip label={organization.user_role} size="small" color="primary" variant="outlined" />
                                                )}
                                            </Stack>
                                        </Box>
                                    </Stack>

                                    <Divider sx={{ my: 3 }} />

                                    <Stack spacing={2}>
                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                                            <Typography variant="body2" sx={{ color: "text.secondary", minWidth: 160, fontWeight: 600 }}>
                                                Name
                                            </Typography>
                                            <Typography variant="body2">{data.name || "—"}</Typography>
                                        </Stack>
                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                                            <Typography variant="body2" sx={{ color: "text.secondary", minWidth: 160, fontWeight: 600 }}>
                                                Email
                                            </Typography>
                                            <Typography variant="body2">{data.email || "—"}</Typography>
                                        </Stack>
                                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                                            <Typography variant="body2" sx={{ color: "text.secondary", minWidth: 160, fontWeight: 600 }}>
                                                Platform role
                                            </Typography>
                                            <Typography variant="body2">{data.role || "—"}</Typography>
                                        </Stack>
                                        {organization?.name && (
                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                                                <Typography variant="body2" sx={{ color: "text.secondary", minWidth: 160, fontWeight: 600 }}>
                                                    Current organization
                                                </Typography>
                                                <Typography variant="body2">{organization.name}</Typography>
                                            </Stack>
                                        )}
                                    </Stack>

                                    <Divider sx={{ my: 3 }} />

                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            component={RouterLink}
                                            to="/user-password"
                                            variant="outlined"
                                            startIcon={<LockOutlinedIcon />}
                                        >
                                            Change password
                                        </Button>
                                    </Stack>
                                </Paper>
                            </Container>
                        </Box>
                        <Footer />
                    </Box>
                </div>
            </div>
        </>
    );
};

export default UserDetails;
